<script>
    import { Swiper, SwiperSlide } from "swiper/svelte";
    import {link} from 'svelte-spa-router'
    import "swiper/css/pagination";
    import "swiper/css/navigation";
    import "swiper/css";
    import ProjectCard from "../../components/project-card/ProjectCard.svelte";
    import {AUTHENTICATION_URL, BASE_URL, PROJECT_STATUSES, sliderOptions} from "../../constants/constants";
    import {onMount} from "svelte";
    import {projectType, isLoaderActive} from "../../store";
    import "./projectListing.css";

    onMount(async () => {await fetchProject()})

    let completedProjects = []
    let liveProjects = []
    let upcomingProjects = []

    function filterProjects (projects) {
        projects.forEach( project => {
            switch (project.attributes.project_status) {
                case PROJECT_STATUSES.COMPLETED:
                    completedProjects.push({id: project.id, ...project.attributes})
                    completedProjects = completedProjects
                    break;
                case PROJECT_STATUSES.LIVE:
                    liveProjects.push({id: project.id, ...project.attributes})
                    liveProjects = liveProjects
                    break;
                case PROJECT_STATUSES.UPCOMING:
                    upcomingProjects.push({id: project.id, ...project.attributes})
                    upcomingProjects = upcomingProjects
                    break;
                default:
                    break
            }
        })
    }

    async function fetchProject () {
        isLoaderActive.set(true);
        const resp = await fetch(`${BASE_URL}/api/projects/?pagination%5Blimit%5D=100&populate=%2A`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization':AUTHENTICATION_URL,
            },
        }).then(response => {
            return response;
        }).then(response=> {
            return response.json()
        }).catch(error=>{
            console.log(error)
        }).finally(() => {
            isLoaderActive.set(false);
        });
        filterProjects(resp.data)
    }
</script>
<div class="container">
    {#if liveProjects.length > 0}
        <div class="on-going-wrapper flex column-direction">
        <a href={`/explore-projects/${PROJECT_STATUSES.LIVE}`} use:link class="see-all" on:click={() => projectType.set(PROJECT_STATUSES.LIVE)}>See All</a>
        <h2 class="slider-title bold">Ongoing Raises</h2>
        <Swiper
                slidesPerView={sliderOptions.slidesPerView}
                spaceBetween={sliderOptions.spaceBetween}
                slidesPerGroup={sliderOptions.slidesPerGroup}
                loop={sliderOptions.loop}
                pagination={sliderOptions.pagination}
                navigation={sliderOptions.navigation}
                modules={sliderOptions.modules}
                breakpoints={sliderOptions.breakPoint}
                class="mySwiper">
            {#each liveProjects as project}
                <SwiperSlide>
                    <ProjectCard {project}/>
                </SwiperSlide>
            {/each}
        </Swiper>
    </div>
    {/if}
    {#if upcomingProjects.length > 0}
        <div class="on-going-wrapper flex column-direction">
            <a href={`/explore-projects/${PROJECT_STATUSES.UPCOMING}`} use:link class="see-all" on:click={() => projectType.set(PROJECT_STATUSES.UPCOMING)}>See All</a>
            <h2 class="slider-title bold">Upcoming Raises</h2>
             <Swiper
                    slidesPerView={sliderOptions.slidesPerView}
                    spaceBetween={sliderOptions.spaceBetween}
                    slidesPerGroup={sliderOptions.slidesPerGroup}
                    loop={sliderOptions.loop}
                    pagination={sliderOptions.pagination}
                    navigation={sliderOptions.navigation}
                    modules={sliderOptions.modules}
                    breakpoints={sliderOptions.breakPoint}
                    class="mySwiper">
                {#each upcomingProjects as project}
                    <SwiperSlide>
                        <ProjectCard {project}/>
                    </SwiperSlide>
                {/each}
            </Swiper>
        </div>
    {/if}
    {#if completedProjects.length > 0}
        <div class="on-going-wrapper flex column-direction">
        <a href={`/explore-projects/${PROJECT_STATUSES.COMPLETED}`} use:link class="see-all" on:click={() => projectType.set(PROJECT_STATUSES.COMPLETED)}>See All</a>
        <h2 class="slider-title bold">Completed Raises</h2>
        <Swiper
                slidesPerView={sliderOptions.slidesPerView}
                spaceBetween={sliderOptions.spaceBetween}
                slidesPerGroup={sliderOptions.slidesPerGroup}
                loop={sliderOptions.loop}
                pagination={sliderOptions.pagination}
                navigation={sliderOptions.navigation}
                modules={sliderOptions.modules}
                breakpoints={sliderOptions.breakPoint}
                class="mySwiper">
            {#each completedProjects as project}
                <SwiperSlide>
                    <ProjectCard {project}/>
                </SwiperSlide>
            {/each}
        </Swiper>
    </div>
    {/if}
    {#if !$isLoaderActive && liveProjects.length === 0 && upcomingProjects.length === 0 && completedProjects.length === 0}
        <div class="no-project-wrapper relative flex items-center flex-text-center">
            <div class="no-project-content flex column-direction items-center">
                <h2>No project to show</h2>
                <a href="/" class="home-return">Return to Home</a>
            </div>
        </div>
    {/if}
</div>
